<template>
  <b-row>
    <b-col sm="4">Select Client:</b-col>
    <b-col sm="8">
      <v-select
        value='id'
        label='name'
        class='select-no-caret'
        v-model='value'
        :options="clientOptions"
        @input="updateValue"
      />
    </b-col>
  </b-row>
</template>

<script>
import vSelect from 'vue-select'
export default {
  name: 'ClientsSelect',
  components: {
    vSelect
  },
  props: ['value'],

  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  },

  computed: {
    clientOptions () {
      return this.$store.getters.clients
    }
  },

}

</script>
